import { GameId } from '@common'

import { useAppSelector } from './useAppSelector'

export function useIsGameAccountConnected(game: GameId) {
  const userProfile = useAppSelector((state) => state.user.profile)
  const application = userProfile?.applications?.find((a) => a.application === game)
  return Boolean(application?.account)
}
